import { automationCapabilityIdRenderer } from 'components/FieldRenderers/Renderers/automation'
import {
    changelogChangesRenderer,
    changelogObjectNameRenderer,
} from 'components/FieldRenderers/Renderers/changelog/changelog'
import { automationCapabilityId } from 'configuration/fieldCreators/automation'
import {
    changeDate,
    changeDateWithProfileTimezone,
    changeReason,
    changes,
    objectName,
    objectType,
    userEmail,
} from 'configuration/fieldCreators/changelog'
import { ChangelogRecord, Field } from 'types'

export const campaignChangelogTableColumnsConfig: Field<ChangelogRecord>[] = [
    objectName({
        fixed: 'left',
        sorter: true,
        renderOptions: {
            render: (cellRenderProps) =>
                changelogObjectNameRenderer({
                    cellRenderProps,
                }),
        },
    }),
    objectType(),
    automationCapabilityId({
        dataIndex: ['automation_capability_id'],
        renderOptions: {
            render: (cellRenderProps) =>
                automationCapabilityIdRenderer({
                    cellRenderProps,
                }),
        },
    }),
    changes({
        dataIndex: ['changes'],
        renderOptions: {
            render: (cellRenderProps) =>
                changelogChangesRenderer({
                    cellRenderProps,
                }),
        },
    }),
    changeReason(),
    userEmail(),
    changeDateWithProfileTimezone(),
]

export const segmentChangelogTableColumnsConfig: Field<ChangelogRecord>[] = [
    changes({
        renderOptions: {
            render: (cellRenderProps) =>
                changelogChangesRenderer({
                    cellRenderProps,
                }),
        },
        dataIndex: ['changes'],
    }),
    userEmail(),
    changeDate({}, 'UTC'),
]
